/**
 * Cloud Functions Base URL Utility
 *
 * Derives the Cloud Functions base URL from the Firebase project ID
 * (VITE_FIREBASE_PROJECT_ID) so it works across all environments
 * (dev, staging, production) without hardcoding project names.
 *
 * - Development: Points to the local Functions emulator
 * - Production:  Constructs the URL from the project ID and region
 */

const FUNCTIONS_REGION = 'us-central1';

/**
 * Returns the base URL for Cloud Functions HTTP endpoints.
 *
 * Examples:
 *   Dev:  http://127.0.0.1:5001/hesvara-prod/us-central1
 *   Prod: https://us-central1-hesvara-prod.cloudfunctions.net
 */
export function getCloudFunctionsBaseUrl(): string {
  const projectId = import.meta.env.VITE_FIREBASE_PROJECT_ID;

  if (import.meta.env.DEV) {
    return `http://127.0.0.1:5001/${projectId}/${FUNCTIONS_REGION}`;
  }

  return `https://${FUNCTIONS_REGION}-${projectId}.cloudfunctions.net`;
}
